import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import React from 'react'
import type {
	FashionAssistantMessage,
	RecommendedProduct,
} from '../../types/messageTypes'
import styles from './FashionAssistantGrid.module.scss'
import { FashionAssistantLook } from './FashionAssitantLook/FashionAssistantLook'

import { ButtonContentLink } from '@fukku/button/ContentLink'
import { useChatBotMessages } from '../../hooks/useChatBotMessages'

export const FashionAssistantGrid = ({
	message,
}: { readonly message: FashionAssistantMessage }) => {
	const { t } = useLabels()

	const { regenerateFAResponse, isRegenerateEnabled } = useChatBotMessages()

	const onRegenerate = () => {
		regenerateFAResponse()
	}

	function isLooksRecommendation(
		data: RecommendedProduct[] | RecommendedProduct[][]
	): data is RecommendedProduct[][] {
		return Array.isArray(data) && data.every((item) => Array.isArray(item))
	}

	return (
		<div className={styles.fashionAssistantGridContainer}>
			{isLooksRecommendation(message.recommendations) ? (
				message.recommendations.map((lookRecommendation, index) => (
					<React.Fragment key={`${index.toString()}`}>
						<p>
							<ClientLabel placeholderValues={{ 1: index + 1 }}>
								{t('assistant.stylist.outfit.title')}
							</ClientLabel>
						</p>
						<FashionAssistantLook
							recommendedLook={lookRecommendation}
							outfitNumber={index}
						/>
					</React.Fragment>
				))
			) : (
				<FashionAssistantLook recommendedLook={message.recommendations} />
			)}
			{isRegenerateEnabled && (
				<ButtonContentLink className={styles.regenerate} onClick={onRegenerate}>
					<ClientLabel>{t('assistant.stylist.regenerate.button')}</ClientLabel>
				</ButtonContentLink>
			)}
		</div>
	)
}
